import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { message, DatePicker, Spin } from "antd";
import Select from "react-select";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { RotateCcw } from "feather-icons-react";
import Table from "../../../core/pagination/datatable.jsx";
import ImageWithBasePath from "../../../core/img/imagewithbasebath.jsx";
import CommonFooter from "../../../core/common/footer/commonFooter.jsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import dayjs from "dayjs";
import axios from "axios";
import { ROLL_CALL_API_BASE_URL } from "../RollCall/RollCallConfig/RollCallConfig.js";

const { RangePicker } = DatePicker;

const VisitorReport = () => {
  const [selectedVisitType, setSelectedVisitType] = useState(0);
  const [selectedStatus, setSelectedStatus] = useState(undefined);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [Employees, setEmployees] = useState(null);
  console.log(Employees);
  const [loading, setLoading] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState(0);
  const [dateRange, setDateRange] = useState(null);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const renderWithTooltip = (text, maxLength = 15) => {
    if (!text) return "N/A";

    const displayText =
      text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;

    return (
      <OverlayTrigger placement="top" overlay={<Tooltip>{text}</Tooltip>}>
        <span style={{ cursor: "pointer" }}>{displayText}</span>
      </OverlayTrigger>
    );
  };

  //columns
  const columns = [
    {
      title: "Visitor Name",
      dataIndex: "Name",
      key: "Name",
      render: (text) => renderWithTooltip(text, 15),
      sorter: (a, b) => a.Name.localeCompare(b.Name),
    },
    {
      title: "Date & Time",
      key: "StartDateTime",
      render: (_, r) => formatDate(r.StartDateTime),
      sorter: (a, b) => new Date(a.StartDateTime) - new Date(b.StartDateTime),
    },

    {
      title: "VisitType",
      dataIndex: "VisitType",
      key: "VisitType",
      sorter: (a, b) => a.VisitType - b.VisitType,
      render: (value) => visitTypeMap[value] || "Unknown",
    },
    {
      title: "MeetingWith",
      dataIndex: "HostedByName",
      key: "HostedByName",
      render: (text) => renderWithTooltip(text, 11),
      sorter: (a, b) => a.HostedByName.localeCompare(b.HostedByName),
    },
    {
      title: "Requestedby",
      dataIndex: "RequestedByName",
      key: "RequestedByName",
      render: (text) => renderWithTooltip(text, 11),
      sorter: (a, b) => a.RequestedByName.localeCompare(b.RequestedByName),
    },
    {
      title: "Purpose",
      dataIndex: "Purpose",
      key: "Purpose",
      render: (text) => renderWithTooltip(text, 13),
      sorter: (a, b) => a.Purpose.localeCompare(b.Purpose),
    },
    {
      title: "Check In&Out",
      key: "checkInOut",
      render: (_, record) => {
        const checkIn = record.CheckInTime || "N/A";
        const checkOut = record.CheckOutTime || "N/A";
        const value = `${checkIn} - ${checkOut}`;

        return renderWithTooltip(value, 12);
      },
      sorter: (a, b) =>
        (a.CheckInTime || "").localeCompare(b.CheckInTime || ""),
    },
    {
      title: "Status",
      key: "Status",
      render: (_, record) => (
        <span className={`badge bg-${getStatusColor(record.Status)} badge-xs`}>
          {statusMap[record.Status] || "Unknown"}
        </span>
      ),
      sorter: (a, b) => a.Status - b.Status,
    },
  ];

  const formatDate = (isoString) => {
    if (!isoString) return "N/A";

    const [datePart, timePart] = isoString.split("T");

    const [year, month, day] = datePart.split("-");
    const [hour, minute] = timePart.split(":");

    return `${day}-${month}-${year} ${hour}:${minute}`;
  };
  const rangePresets = [
    {
      label: "Today",
      value: [dayjs().startOf("day"), dayjs().endOf("day")],
    },
    {
      label: "This Week",
      value: [dayjs().startOf("week"), dayjs().endOf("week")],
    },
    {
      label: "This Month",
      value: [dayjs().startOf("month"), dayjs().endOf("month")],
    },
    {
      label: "This Year",
      value: [dayjs().startOf("year"), dayjs().endOf("year")],
    },
  ];
  const visitTypeOptions = [
    { label: "All Types", value: 0 },
    { label: "Meeting", value: 1 },
    { label: "Client", value: 2 },
    { label: "Vendor", value: 3 },
    { label: "Candidate", value: 4 },
    { label: "Other", value: 5 },
  ];
  const statusOptions = [
    { label: "All Status", value: undefined },
    { label: "Pending", value: 0 },
    { label: "Approved", value: 1 },
    { label: "Check-In", value: 2 },
    { label: "Check-Out", value: 3 },
    { label: "Expired", value: 4 },
  ];
  // const durationOptions = [
  //     { value: "30", label: "30 Minutes" },
  //     { value: "60", label: "1 Hour" },
  //     { value: "120", label: "2 Hours" },
  //     { value: "180", label: "3 Hours" }
  // ];
  const handleRefresh = () => {
    // Reset all filters
    setSelectedVisitType(0);
    setSelectedStatus(undefined);
    setSelectedPerson(0);
    setDateRange(null);

    // Fetch fresh data
    fetchVisitingData({
      hostedBy: 0,
      visitType: 0,
      status: undefined,
      fromDate: undefined,
      toDate: undefined,
    });
  };

  const statusMap = Object.fromEntries(
    statusOptions.map((s) => [s.value, s.label]),
  );
  const visitTypeMap = Object.fromEntries(
    visitTypeOptions
      .filter((v) => v.value !== 0)
      .map((v) => [v.value, v.label]),
  );
  const onRangeChange = (dates) => {
    setDateRange(dates);
    if (dates) {
      fetchVisitingData({
        visitType: selectedVisitType,
        status: selectedStatus,
        fromDate: dates[0].format("DD-MM-YYYY"),
        toDate: dates[1].format("DD-MM-YYYY"),
      });
    } else {
      fetchVisitingData({
        visitType: selectedVisitType,
        status: selectedStatus,
      });
    }
  };
  const getStatusColor = (status) => {
    switch (status) {
      case 0:
        return "warning";
      case 1:
        return "success";
      case 2:
        return "info";
      case 3:
        return "primary";
      case 4:
        return "danger";
      default:
        return "secondary";
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");
    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  const fetchVisitingData = async (filters = {}) => {
    if (!superIdData || !tokenData) return;

    setLoading(true);

    try {
      const { data } = await axios.get(
        `${ROLL_CALL_API_BASE_URL}Visitor/Pass/getvisitorsList`,
        {
          params: {
            SuperId: superIdData,
            HostedBy: filters.hostedBy || 0,
            status:
              filters.status && filters.status !== "all" ? filters.status : 0,
            VisitType:
              filters.visitType && filters.visitType !== "all"
                ? filters.visitType
                : 0,
            StartDate: filters.fromDate || 0,
            EndDate: filters.toDate || 0,
          },
          headers: {
            Authorization: `Bearer ${tokenData}`,
          },
        },
      );

      if (data?.status) {
        setData(data.ResultData || []);
      } else {
        setData([]);
      }
    } catch (err) {
      console.error(err);
      message.error("Failed to load");
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!superIdData || !tokenData) return;

    fetchVisitingData({
      hostedBy: selectedPerson,
      visitType: selectedVisitType,
      status: selectedStatus,
      fromDate: dateRange?.[0]?.format("YYYY-MM-DD"),
      toDate: dateRange?.[1]?.format("YYYY-MM-DD"),
    });
  }, [
    superIdData,
    tokenData,
    selectedVisitType,
    selectedStatus,
    dateRange,
    selectedPerson,
  ]);

  useEffect(() => {
    if (!superIdData) return;

    const fetchEmployees = async () => {
      try {
        const response = await axios.get(
          `${ROLL_CALL_API_BASE_URL}portal/emp/getemployeedropdown`,
          {
            params: {
              superid: superIdData,
              BranchId: 0,
              DeptId: 0,
            },
            headers: {
              Authorization: `Bearer ${tokenData}`,
            },
          },
        );

        if (response.data.status) {
          setEmployees(response.data.ResultData);
        }
      } catch (err) {
        console.error("Employee fetch error:", err);
      }
    };

    fetchEmployees();
  }, [superIdData, tokenData]);

  const exportPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    doc.text("Visitor Report", 14, 10);

    const rows = data.map((r) => [
      r.Name || "N/A",
      formatDate(r.StartDateTime),
      visitTypeMap[r.VisitType] || "Unknown",
      r.HostedByName || "N/A",
      r.RequestedByName || "N/A",
      r.Purpose || "N/A",
      `${r.CheckInTime || "N/A"} - ${r.CheckOutTime || "N/A"}`,
      statusMap[r.Status] || "Unknown",
    ]);

    doc.autoTable({
      head: [
        [
          "Visitor Name",
          "Date & Time",
          "Visit Type",
          "Meeting With",
          "Requested By",
          "Purpose",
          "Check In & Out",
          "Status",
        ],
      ],
      body: rows,
      startY: 20,
      styles: { fontSize: 8 }, // optional: better fit in landscape
    });

    doc.save("Visiting_Report.pdf");
  };
  const exportExcel = () => {
    const exportData = data.map((r) => ({
      "Visitor Name": r.Name || "N/A",
      "Date & Time": formatDate(r.StartDateTime),
      "Visit Type": visitTypeMap[r.VisitType] || "Unknown",
      "Meeting With": r.HostedByName || "N/A",
      "Requested By": r.RequestedByName || "N/A",
      Purpose: r.Purpose || "N/A",
      "Check In & Out": `${r.CheckInTime || "N/A"} - ${r.CheckOutTime || "N/A"}`,
      Status: statusMap[r.Status] || "Unknown",
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Visitor Report");

    XLSX.writeFile(wb, "Visiting_Report.xlsx");
  };

  return (
    <>
      <style>
        {`
   

    .ctc-table1 .ant-table-thead > tr > th {
      background-color: #d2e6f5ff !important; 
    }

    .ctc-table1 table {
      table-layout: auto;
    }

    .ctc-info-2col {
      display: grid;
      column-gap: 10px;
      row-gap: 8px;
    }

    .ctc-pair {
      display: flex;
      align-items: flex-start;
    }

    .ctc-label {
      font-weight: 600;
    }

    .ctc-value {
      font-weight: 500;
    }
  `}
      </style>
      <div className="page-wrapper pt-5">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item">Visitor Report</h4>
                  </ol>
                </nav>
                <h6>Manage your Visitor Report</h6>
              </div>
            </div>

            <ul className="table-top-head">
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>PDF</Tooltip>}
                >
                  <Link onClick={exportPDF}>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="pdf"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Excel</Tooltip>}
                >
                  <Link onClick={exportExcel}>
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="excel"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Refresh</Tooltip>}
                >
                  <Link onClick={handleRefresh}>
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>

          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set col-lg-auto col-md-12 mb-md-1 mb-sm-1 mb-lg-0"></div>
              <div className="col-lg-auto col-md-12 mt-md-4 mt-sm-4 mt-lg-0">
                <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                  {/* Year */}
                  <div className="me-2">
                    <RangePicker
                      format="DD-MM-YYYY"
                      presets={rangePresets}
                      onChange={onRangeChange}
                    />
                  </div>
                  <div className="me-2">
                    <Select
                      value={
                        Employees?.length
                          ? Employees.map((emp) => ({
                              value: emp?.RegId,
                              label: emp?.UserWithBadge,
                            })).find((opt) => opt.value === selectedPerson)
                          : null
                      }
                      onChange={(option) =>
                        setSelectedPerson(option?.value || 0)
                      }
                      options={
                        Employees?.map((emp) => ({
                          value: emp?.RegId,
                          label: emp?.UserWithBadge,
                        })) || []
                      }
                      placeholder="Meeting With"
                      isClearable
                    />
                  </div>
                  {/* Visit Type */}
                  <div className="me-2">
                    <Select
                      value={visitTypeOptions.find(
                        (opt) => opt.value === selectedVisitType,
                      )}
                      style={{ width: 150 }}
                      onChange={(option) =>
                        setSelectedVisitType(option?.value || 0)
                      }
                      options={visitTypeOptions}
                    />
                  </div>

                  {/* Status */}
                  <div className="me-2">
                    <Select
                      value={statusOptions.find(
                        (opt) => opt.value === selectedStatus,
                      )}
                      style={{ width: 150 }}
                      onChange={(option) => setSelectedStatus(option?.value)}
                      options={statusOptions}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="card-body pb-0">
              <div className="table-responsive">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : data.length > 0 ? (
                  <Table
                    columns={columns}
                    dataSource={data}
                    rowKey="id"
                    pgno={true}
                  />
                ) : (
                  <p className="text-center my-4">No data available</p>
                )}
              </div>
            </div>
          </div>
        </div>

        <CommonFooter />
      </div>
    </>
  );
};

export default VisitorReport;
